import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';

import React from 'react';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import messages from '../../messages';

import style from './item-stock.module.less';

export const UntrackedStockLevels = () => (
  <Text
    className={style['untracked-stock-levels']}
    element='span'
    textType={TextType.Caption}
    value={
      <>
        <FontAwesomeIcon className={classnames(style.icon, style['untracked-icon'])} icon={faQuestionCircle} />
        <FormattedMessage {...messages.noStock} />
      </>
    }
  />
);
